module.exports = __webpack_public_path__ + "static/media/sitrack-icon.f681dc43.svg";